export default "<ngx-alerts></ngx-alerts>\n<ng-http-loader></ng-http-loader>\n<iframe  height=\"900\" width=\"1900\"   [src]=\"urlSafe\"></iframe>\n";